import React from "react";

function Footer(){
    return (
      <footer id="footer">
        <i class="footer-icons fa-brands fa-twitter"></i>
        <i class="footer-icons fa-brands fa-facebook"></i>
        <i class="footer-icons fa-brands fa-instagram"></i>
        <i class="footer-icons fa-solid fa-envelope"></i>
        <p>© Copyright flavourly</p>
      </footer>
    );
}

export default Footer;